"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.util = void 0;

var _listResponse = require("./utils/list-response");

var _pagingOptions = require("./utils/paging-options");

var _sortingOptions = require("./utils/sorting-options");

var util = {
  makeListResponse: _listResponse.makeListResponse,
  makePagingOptions: _pagingOptions.makePagingOptions,
  makeSortingOptions: _sortingOptions.makeSortingOptions
};
exports.util = util;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/gfrl/index.js
// module id = 243
// module chunks = 0